export default __webpack_public_path__ + "static/media/person_3.b5f4f0f5.png";